import styles from './ButtonUp.module.scss';
import { Link } from 'react-scroll';

export const ButtonUp = ({ showButtonUp }) => {
  return (
    <div className={`${styles.buttonUp} ${showButtonUp
      ? styles.buttonUpActive
      : styles.buttonUpUnactive}`}>
      <Link
        to="header"
        spy={true}
        smooth={true}
        duration={500}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 65 59" fill="none">
          <path d="M33.6104 3.32845L44.6302 14.5075C47.7843 17.5475 50.2591 18.9495 53.4245 19.7286C55.1271 20.1476 56.4879 21.6532 56.4862 23.552C56.4845 25.7265 54.8705 27.6136 52.5981 27.6155C50.3257 27.6174 0.0854749 27.6581 0.0854749 27.6581C0.0399294 27.6583 0.00297785 27.695 0.00294171 27.7402L2.91176e-08 31.3209C-3.78319e-05 31.3662 0.0368515 31.4029 0.0823953 31.4029L52.5951 31.3601C57.217 31.3564 57.7569 38.1891 53.3878 39.2412C50.1173 40.0289 47.5354 41.4654 44.1799 44.8048L33.5611 55.6723C33.53 55.7041 33.53 55.7548 33.561 55.7865L35.9436 58.2253C35.9761 58.2585 36.0299 58.2583 36.0622 58.2248L64.977 29.589C65.0076 29.5571 65.0076 29.5069 64.977 29.4753L36.1119 0.775022C36.0796 0.741706 36.0259 0.741651 35.9934 0.774908L33.6103 3.21393C33.579 3.24588 33.5791 3.2967 33.6104 3.32845Z" fill="#CCD6F6">
          </path>
        </svg>
      </Link>
    </div>
  )
}